import { useSignupSelector } from "../hooks";
import { State } from "../state/types";

export const selectMetadata = (state: State) => state.metadata;
export const useMetadata = () => useSignupSelector(selectMetadata);

export const selectDraftId = (state: State) => state.metadata.draftId;
export const useDraftId = () => useSignupSelector(selectDraftId);

export const selectError = (state: State) => state.metadata.error;
export const useError = () => useSignupSelector(selectError);

export const selectIsLoading = (state: State) => state.metadata.loading;
export const useIsLoading = () => useSignupSelector(selectIsLoading);
